<app-dialog-container title="workingCopyDepartmentChangeTitle" confirmButtonText="continue">
  <div class="warning">
    <mat-icon class="warning__icon">warning</mat-icon>
    <p
      class="warning__message"
      [innerHTML]="
        'workingCopyDepartmentChangeWarning' | translate: { departmentName: escapedDepartmentName }
      "
    ></p>
  </div>
</app-dialog-container>
